module.exports = __webpack_public_path__ + "img/TreeOpen.3674253a.svg";